<template>
    <div class="add_favourite" v-if="seen">
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" viewBox="0 0 100 100" width="40px" height="40px" class="lds-dual-ring" style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;"><circle cx="50" cy="50" fill="none" stroke-linecap="round" stroke="#039aed" r="30" stroke-dasharray="41.41592653589793 41.41592653589793" stroke-width="8"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></circle></svg>
                Removing file from favourite
        </div>
    </div>
</template>
<script>
import cookies from '@/services/cookies'
export default {
    data() {
        return {
            seen: false,
            index: null
        }
    },
    methods: {
        logincall() {
            this.$parent.logincall()
        },
        remove(index, id) {
            this.seen = true
            this.index = index

            let that = this
            let data = {
                token: cookies.getCookie('token'),
                file_id: id
            }
            this.$socket.emit('removefav', data, function(data) {
                if(data.data === true) {
                    that.$store.getters.DIRECTORY_CHILDREN[that.index].is_favourite = false
                    if(localStorage.getItem('current_directory') === 'My Favourite') {
                        that.$store.getters.DIRECTORY_CHILDREN.splice(index, 1)
                    }
                    that.seen = false
                }

                if(data.data === false) {
                    that.seen = false
                    that.logincall()
                    that.$router.push('/login')
                }
            });
        }
    }
}
</script>
